export default __webpack_public_path__ + "static/media/Barr.94ed20b6.png";